<template>
  <div>
    <Header />
    <MobileMenu
      class="min-[1024px]:hidden [&_button]:right-[14vw] [&_button]:top-[14vw] md:[&_button]:right-[16vw] md:[&_button]:top-[16vw] [&_button]:min-[900px]:top-20"
    />
    <div class="bg-avu-gray">
      <div
        class="flex h-[34vw] w-3/5 items-center bg-avu-blue px-6 py-5 md:h-[36.1vw] min-[900px]:h-[20vw] xl:py-[50px] xl:pl-16 xl:pr-[37px]"
      >
        <h1
          v-if="pageTitle"
          class="min-text-xl text-pretty font-avuDisplay text-[6.4vw]/[6.4vw] md:text-[6.35vw] min-[900px]:text-[4vw]/[5vw] xl:text-[4.59vw]/[5.5vw]"
        >
          {{ pageTitle }}
        </h1>
      </div>

      <div
        ref="floatBlock"
        class="fixed right-0 top-0 z-30 mt-[122px] hidden w-2/5 grid-cols-2 grid-rows-[repeat(2,minmax(20vw,auto))] min-[1024px]:grid"
      >
        <div class="col-span-1 col-start-2 bg-avu-pink" />
        <div class="col-start-1 row-span-2 bg-avu-pink" />
      </div>

      <slot />
    </div>
    <Footer ref="footerRef" />
  </div>
</template>

<script setup>
  const floatBlock = ref(null);
  const footerRef = ref(null);
  const overlapPx = ref(0);
  let lastScrollY = 0;
  let lastFixedTop = 0;

  const checkOverlap = () => {
    if (!floatBlock.value || !footerRef.value.$el) return;

    const floatRect = floatBlock.value.getBoundingClientRect();
    const footerRect = footerRef.value.$el.getBoundingClientRect();
    const currentScrollY = window.scrollY;
    const scrollDirection = currentScrollY < lastScrollY ? "up" : "down";
    const maxTop =
      footerRect.top + currentScrollY - floatBlock.value.clientHeight / 2 - 122;

    // Check the overlap with the footer
    if (floatRect.bottom > footerRect.top) {
      overlapPx.value = floatRect.bottom - footerRect.top;
    } else {
      overlapPx.value = 0;
    }

    // When scrolling DOWN: if the block reaches the footer, change its position to absolute
    if (
      scrollDirection === "down" &&
      overlapPx.value >= floatBlock.value.clientHeight / 2 &&
      floatBlock.value.classList.contains("fixed")
    ) {
      floatBlock.value.classList.remove("fixed");
      floatBlock.value.classList.add("absolute");
      floatBlock.value.style.top = `${Math.min(floatRect.top + currentScrollY - 122, maxTop)}px`;
      lastFixedTop = floatRect.top + currentScrollY - 122;
    }

    // When scrolling UP: if we're not overlapping footer or we've scrolled above the detach point
    if (
      scrollDirection === "up" &&
      floatBlock.value.classList.contains("absolute") &&
      (currentScrollY <= lastFixedTop || floatRect.bottom < footerRect.top)
    ) {
      floatBlock.value.classList.remove("absolute");
      floatBlock.value.classList.add("fixed");
      floatBlock.value.style.top = "0px"; // Reset to original top position
    }

    // Update the last scrollY value
    lastScrollY = currentScrollY;
  };

  onMounted(() => {
    nextTick(() => {
      if (floatBlock.value) {
        floatBlock.value.classList.add("fixed");
      }
      window.addEventListener("scroll", checkOverlap);
    });
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", checkOverlap);
  });

  const { globalPageTitle } = useGlobalState();
  const pageTitle = computed(() => globalPageTitle.value || "");

  useHead(() => ({
    title: `LARGE AVU | ${pageTitle.value}`,
  }));
</script>
